<div class="login-box">
  <div class="login-logo">
    <img src="assets/img/bottom_logo.svg" alt="Paymish logo" />
  </div>
  <div class="login-box-body">
    <h3 class="page">
      <strong>Join Team</strong>
    </h3>
    <form [formGroup]="joinTeamForm" (ngSubmit)="onSubmit($event)">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group has-feedback">
            <label for="firstName">First Name</label>
            <input
              trim="blur"
              type="text"
              placeholder="First Name"
              formControlName="firstName"
              class="form-control"
            />
            <div
              *ngIf="
                formControls.firstName.touched && formControls.firstName.invalid
              "
              class="help-block"
            >
              <span *ngIf="formControls.firstName.errors?.required">{{
                "SIGNUP_PAGE.FIELD_REQUIRED" | translate
              }}</span>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="form-group has-feedback">
            <label for="lastName">Last Name</label>
            <input
              trim="blur"
              type="text"
              placeholder="Last Name"
              formControlName="lastName"
              class="form-control"
            />
            <div
              *ngIf="
                formControls.lastName.touched && formControls.lastName.invalid
              "
              class="help-block"
            >
              <span *ngIf="formControls.lastName.errors?.required">{{
                "SIGNUP_PAGE.FIELD_REQUIRED" | translate
              }}</span>
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group has-feedback">
            <label for="dialingCodeId">Code</label>
            <select class="form-control" formControlName="dialingCodeId">
              <option *ngFor="let opt of dialingCode" [value]="opt.id">
                {{ opt.dialingCode }}
              </option>
            </select>
            <div
              *ngIf="
                formControls.dialingCodeId.touched &&
                formControls.dialingCodeId.invalid
              "
              class="help-block"
            >
              <span *ngIf="formControls.dialingCodeId.errors?.required">{{
                "SIGNUP_PAGE.FIELD_REQUIRED" | translate
              }}</span>
            </div>
          </div>
        </div>

        <div class="col-md-8">
          <div class="form-group has-feedback">
            <label for="phoneNumber">Phone Number</label>
            <input
              type="text"
              placeholder="Phone Number"
              formControlName="phoneNumber"
              class="form-control"
              minlength="10"
            />
            <div
              *ngIf="
                formControls.phoneNumber.touched &&
                formControls.phoneNumber.invalid
              "
              class="help-block"
            >
              <span *ngIf="formControls.phoneNumber.errors?.required">{{
                "SIGNUP_PAGE.FIELD_REQUIRED" | translate
              }}</span>
              <span *ngIf="formControls.phoneNumber.errors?.pattern">{{
                "SIGNUP_PAGE.PHONE_NUMBER_ACCEPT_10_DIGIT" | translate
              }}</span>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="form-group has-feedback">
            <label for="jobTitle">Job Title</label>
            <input
              trim="blur"
              type="text"
              placeholder="Job Title"
              formControlName="jobTitle"
              class="form-control"
            />
            <div
              *ngIf="
                formControls.jobTitle.touched && formControls.jobTitle.invalid
              "
              class="help-block"
            >
              <span *ngIf="formControls.jobTitle.errors?.required">{{
                "SIGNUP_PAGE.FIELD_REQUIRED" | translate
              }}</span>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="form-group has-feedback">
            <label for="password">Password</label>
            <p class="position-relative">
              <input
                [type]="showPassword ? 'text' : 'password'"
                class="form-control"
                placeholder="{{ 'SIGNUP_PAGE.PASSWORD' | translate }}"
                formControlName="password"
              />
              <i
                class="bi bi-eye eye-icon"
                (click)="togglePasswordVisibility()"
                *ngIf="!showPassword"
              ></i>
              <i
                class="bi bi-eye-slash eye-icon"
                (click)="togglePasswordVisibility()"
                *ngIf="showPassword"
              ></i>
            </p>
            <div
              *ngIf="
                formControls.password.touched && formControls.password.invalid
              "
              class="help-block"
            >
              <span *ngIf="formControls.password.errors?.required">{{
                "SIGNUP_PAGE.PLEASE_ENTER_PASSWORD" | translate
              }}</span>
              <span *ngIf="formControls.password.errors?.pattern">{{
                "SIGNUP_PAGE.PASSWORD_MINLENGTH" | translate
              }}</span>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="form-group has-feedback">
            <label for="isDeveloper">Are you a developer?</label>
            <input type="checkbox" formControlName="isDeveloper" class="pad-left10"/> I am a
            developer
          </div>
        </div>

        <div class="col-md-12">
          <button
            type="button"
            class="btn btn-primary btn-flat float-right"
            (click)="onSubmit($event)"
            [disabled]="joinTeamForm.invalid"
          >
            Join Team
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
